<template>
  <div class="survey-result-info">
    <div class="desc">{{ desc }}</div>
    <div class="list">
      <div class="item"
           v-for="(item, index) in list"
           :key="index"
      >
        {{ item }}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SurveyResultInfo',
    props: {
      list: {
        type: Array,
        required: true,
      },
      desc: {
        type: String,
        required: true,
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .survey-result-info {
    padding: @size-base @size-medium 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .desc {
    font-size: @font-size-medium;
    color: @color-text-lighter;
    line-height: 1;
  }

  .list {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .item {
    min-width: 136px;
    height: @size-extra-medium;
    margin-left: @size-extra-small;
    padding: 12px 24px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 30px;
    background: @color-primary-lighter;
    font-size: @font-size-small;
    color: @color-primary-aide;
    line-height: 1;
  }

</style>
